/* ==========================================================
   Entrance animation (scroll reveal) — controller
   Watches every [data-reveal] element and adds .is-revealed
   the first time it scrolls into view. Cards sharing a common
   parent (e.g. a grid/list) get an auto-incrementing
   --reveal-index so they stagger in nicely.
========================================================== */

(function () {
  function init() {
    var items = document.querySelectorAll('[data-reveal]');
    if (!items.length) return;

    // Assign a stagger index per sibling group so cards in the
    // same grid/list cascade in, while unrelated sections don't
    // inherit each other's delay.
    var groups = new Map();
    items.forEach(function (el) {
      var parent = el.parentElement;
      var index = groups.get(parent) || 0;
      el.style.setProperty('--reveal-index', Math.min(index, 8));
      groups.set(parent, index + 1);
    });

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    items.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-scan when new content is injected (e.g. section re-render in theme editor)
  document.addEventListener('shopify:section:load', init);
})();
